import styled from 'styled-components';

export const DeveloperToolsSlidePanelStyled = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--secondary-color, #fafafa);
  overflow: hidden;
  width: 100%;
  height: 3.5em;
  border-radius: 0 0 0.375em 0.375em;
  transition: 0.5s ease;

  &.open {
    height: 100%;
    overflow-y: auto;
  }
`;

export const DeveloperToolsHeadingStyled = styled.div`
  display: flex;
  padding: 0.75em 1em;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-top: 3px solid var(--color-border-low-contrast, #f0f0f0);

  &:hover {
    cursor: pointer;
    border-top: 3px solid var(--color-border-mid-contrast, #dbdbdb);

    #devtool-toggle {
      background: var(--primary-color, #00304d);
      color: var(--secondary-color, #fafafa);
    }
  }

  div:first-child {
    display: flex;
    align-items: center;
    gap: 0.25em;
    flex: 1 0 0;

    svg {
      width: 28px;
      height: 28px;
    }
    span {
      color: var(--color-text-high-contrast, #444);

      font-size: 0.875em;
      font-style: normal;
      font-weight: 700;
      line-height: 1.5em; /* 171.429% */
    }
  }

  div:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1em;
    position: relative;

    button {
      display: flex;
      padding: 0.25em 0.75em;
      justify-content: center;
      align-items: center;
      gap: 0.5em;

      border: unset;
      border-radius: 6.25em;
      background: var(--color-neutral-20, #f0f0f0);

      color: var(--color-text-high-contrast, #444);

      font-size: 0.875em;
      font-style: normal;
      font-weight: 700;
      line-height: 1.5em; /* 171.429% */

      .focus-ring {
        position: absolute;
        width: calc(100% + 0.5em);
        height: 2.5em;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      &:focus {
        .focus-ring {
          border: 2px solid var(--a11y);
          border-radius: 6.25em;
        }
      }
    }
  }
`;
